webpackJsonp([1],{

/***/ 111:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 113:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 114:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 115:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 117:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.be50dde.png";

/***/ }),

/***/ 159:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(113)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-790cf253",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 160:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(87),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-994b9cee",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(88),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-535d53a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(116)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b2acb318",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 163:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(114)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(90),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7bd01244",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(117)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(91),
  /* template */
  __webpack_require__(171),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('Dashboard', {
    attrs: {
      "design": _vm.designs,
      "demo": _vm.demo
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "transparent"
  }, [_vm._l((_vm.demo['picture-naming']), function(name) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/picture-naming/' + name + '.gif'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.demo['lexical-decision']), function(kinds, lang) {
    return _c('li', [_vm._l((kinds), function(items, kind) {
      return _vm._l((items), function(name) {
        return _c('img', {
          attrs: {
            "src": './static/lexical-decision/' + lang + '-' + kind + '/' + name + '.png'
          }
        })
      })
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.demo['iq-tester']), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/iq-tester/' + item.Q + '.jpg'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.designs['picture-naming']), function(name) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/picture-naming/' + name + '.gif'
      }
    })])
  }), _vm._v(" "), _vm._l((_vm.designs['lexical-decision']), function(kinds, lang) {
    return _c('li', [_vm._l((kinds), function(items, kind) {
      return _vm._l((items), function(name) {
        return _c('img', {
          attrs: {
            "src": './static/lexical-decision/' + lang + '-' + kind + '/' + name + '.png'
          }
        })
      })
    })], 2)
  }), _vm._v(" "), _vm._l((_vm.designs['iq-tester']), function(item) {
    return _c('li', [_c('img', {
      attrs: {
        "src": './static/iq-tester/' + item.Q + '.jpg'
      }
    })])
  })], 2)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(157)
    }
  }), _vm._v(" "), _c('span', [_vm._v("sychio")])])
}]}

/***/ }),

/***/ 166:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    staticClass: "stage-pic",
    style: ({
      'background-image': 'url(' + _vm.imageSrc + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.feedback))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-dot"
  }), _vm._v(" "), (_vm.status === 'playing') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 167:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    class: ['stage-arrow', {
      'macos': _vm.isMac
    }]
  }, [_c('span', {
    class: [_vm.result.type, _vm.result.direction]
  }, [_c('span', [_vm._v(_vm._s(_vm.arrowText))])])]), _vm._v(" "), _c('div', {
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.feedback))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), (_vm.status === 'playing') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "transparent",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 168:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    staticClass: "stage-cycle"
  }, [_c('span', {
    class: [_vm.result.type, _vm.result.direction]
  })]), _vm._v(" "), _c('div', {
    staticClass: "feedback"
  }, [_vm._v(_vm._s(_vm.feedback))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), (_vm.status === 'playing') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "transparent",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 169:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('h5', [_vm._v(_vm._s(_vm.item.Q))]), _vm._v(" "), _c('div', {
    staticClass: "stage-pic",
    style: ({
      'background-image': 'url(' + _vm.imageSrc + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "patch"
  }), _vm._v(" "), (_vm.status === 'playing') ? _c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.end
    }
  }) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 170:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status),
      expression: "status"
    }],
    class: ['stage', 'stage-' + _vm.status]
  }, [_c('div', {
    staticClass: "stage-pic",
    style: ({
      'background-image': 'url(' + _vm.imageSrc + ')'
    })
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-cross"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-dot"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-asterisk"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-lang"
  }, [_vm._v(_vm._s(_vm.languageSay))])])
},staticRenderFns: []}

/***/ }),

/***/ 171:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "phone-viewport"
  }, [_c('section', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "col-half"
  }, [_c('md-input-container', [_c('label', [_vm._v("Number/编号")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.yourname),
      callback: function($$v) {
        _vm.yourname = $$v
      },
      expression: "yourname"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Contact/联系方式")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.contact),
      callback: function($$v) {
        _vm.contact = $$v
      },
      expression: "contact"
    }
  })], 1)], 1), _vm._v(" "), _c('md-input-container', [_c('md-switch', {
    model: {
      value: (_vm.realMode),
      callback: function($$v) {
        _vm.realMode = $$v
      },
      expression: "realMode"
    }
  }, [_vm._v(_vm._s(_vm.realMode ? 'Experiment' : 'Practice') + " Mode/" + _vm._s(_vm.realMode ? '实测' : '示例') + "模式")])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Test Type/测试类型")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type"
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": _vm.TYPE_PIC
    }
  }, [_vm._v("Picture Naming/图片命名")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_LEX
    }
  }, [_vm._v("Lexical Decision/词汇判断")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_FLANKER
    }
  }, [_vm._v("Flanker/箭头测试")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_SIMON
    }
  }, [_vm._v("Simon/西蒙测试")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": _vm.TYPE_IQ
    }
  }, [_vm._v("IQ Test/IQ测试")])], 1)], 1), _vm._v(" "), (_vm.type === 'lexical-decision') ? _c('md-input-container', [_c('label', [_vm._v("Languages/语言")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type"
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "chinese"
    }
  }, [_vm._v("Chiese/中文")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "uyghur"
    }
  }, [_vm._v("Uyghur/维文")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.showError && !_vm.contact) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("Please enter contact/请填写联系方式")]) : _vm._e(), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-accent",
    nativeOn: {
      "click": function($event) {
        _vm.start($event)
      }
    }
  }, [_vm._v("Start/开始")]), _vm._v(" "), (_vm.hasData && _vm.realMode) ? _c('md-button', {
    staticClass: "md-raised md-primary",
    nativeOn: {
      "click": function($event) {
        _vm.download($event)
      }
    }
  }, [_vm._v("Export/导出")]) : _vm._e(), _vm._v(" "), (_vm.realMode && _vm.hasData) ? _c('md-button', {
    staticClass: "md-raised md-warn",
    nativeOn: {
      "click": function($event) {
        _vm.upload($event)
      }
    }
  }, [_vm._v("Save/保存")]) : _vm._e()], 1), _vm._v(" "), _c('section', {
    ref: "container",
    class: ['container', {
      'processing': _vm.current >= 0
    }]
  }, [_vm._l((_vm.list), function(item, index) {
    return (_vm.current >= (index + 1)) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current <= (index + 1)),
        expression: "current <= (index + 1)"
      }]
    }, [_c(_vm.type, {
      tag: "component",
      attrs: {
        "item": item,
        "language": _vm.language
      },
      on: {
        "end": _vm.next
      }
    })], 1) : _vm._e()
  }), _vm._v(" "), (_vm.current === 0) ? _c('div', {
    staticClass: "instruction"
  }, [_c('input', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "transparent",
    attrs: {
      "type": "text"
    },
    on: {
      "keyup": _vm.play
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "instruction-content"
  }, [_c('p', {
    staticClass: "instruction-header"
  }, [_vm._v(_vm._s(_vm.instructionContent.header))]), _vm._v(" "), _c('p', {
    staticClass: "instruction-body",
    domProps: {
      "innerHTML": _vm._s(_vm.instructionContent[_vm.sumType])
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "instruction-footer"
  }, [_vm._v(_vm._s(_vm.instructionContent.footer))])])]) : _vm._e()], 2), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [(_vm.type === _vm.TYPE_PIC) ? _c('md-list', _vm._l((_vm.results[_vm.TYPE_PIC]), function(result, index) {
    return _c('md-list-item', {
      key: "index",
      attrs: {
        "href": _vm.blobUrl(result.record),
        "target": '_blank'
      }
    }, [_c('md-avatar', [_c('img', {
      attrs: {
        "src": result.src
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(result.name) + " - (" + _vm._s(result.response) + "ms)")]), _vm._v(" "), _c('span', [_vm._v("[" + _vm._s(result.language) + "]")])], 1)
  })) : _vm._e(), _vm._v(" "), _vm._l(([_vm.TYPE_LEX_CN, _vm.TYPE_LEX_UG]), function(typeLex, typeIdx) {
    return (_vm.type === _vm.TYPE_LEX) ? _c('md-list', {
      key: "typeIdx"
    }, _vm._l((_vm.results[typeLex]), function(result, index) {
      return (_vm.sumType === typeLex) ? _c('md-list-item', {
        key: "index"
      }, [_c('md-avatar', [_c('img', {
        attrs: {
          "src": result.src
        }
      })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(result.name) + " - (" + _vm._s(result.response) + "ms)")]), _vm._v(" "), _c('span', [_vm._v("[" + _vm._s(result.language) + "]")]), _vm._v(" "), _c('small', [_vm._v("Choice/选择(Fact/实际)：" + _vm._s(result.selection ? 'True/真' : 'False/假') + "(" + _vm._s(!result.isNon ? 'True/真' : 'False/假') + ")")]), _vm._v(" "), (result.selection !== result.isNon) ? _c('md-icon', {
        staticClass: "md-primary",
        attrs: {
          "md-theme": "green"
        }
      }, [_vm._v("∨")]) : _c('md-icon', {
        staticClass: "md-warn",
        attrs: {
          "md-theme": "orange"
        }
      }, [_vm._v("x")])], 1) : _vm._e()
    })) : _vm._e()
  }), _vm._v(" "), (_vm.type === _vm.TYPE_FLANKER) ? _c('md-list', _vm._l((_vm.results[_vm.sumType]), function(result, index) {
    return _c('md-list-item', {
      key: "index"
    }, [_c('span', [(result.type === 'con') ? [_vm._v("Congruent/一致")] : (result.type === 'incon') ? [_vm._v("Incongruent/不一致")] : (result.type === 'neu') ? [_vm._v("Neutral/中立")] : _vm._e()], 2), _vm._v(" "), _c('span', [_c('small', [_vm._v("Selection/选择: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(result.selection))]), _vm._v(" "), _c('small', [_vm._v(" - " + _vm._s(result.response) + "ms")]), _vm._v(" "), (result.selection === result.direction) ? _c('md-icon', {
      staticClass: "md-primary",
      attrs: {
        "md-theme": "green"
      }
    }, [_vm._v("∨")]) : _c('md-icon', {
      staticClass: "md-warn",
      attrs: {
        "md-theme": "orange"
      }
    }, [_vm._v("x")])], 1)])
  })) : _vm._e(), _vm._v(" "), (_vm.type === _vm.TYPE_SIMON) ? _c('md-list', _vm._l((_vm.results[_vm.sumType]), function(result, index) {
    return _c('md-list-item', {
      key: "index"
    }, [_c('md-avatar', {
      style: ({
        background: result.type === 'blue' ? '#0c83e8' : '#e80d0d'
      })
    }), _vm._v(" "), _c('span', [(result.type === 'blue') ? [_vm._v("Blue/蓝色")] : (result.type === 'red') ? [_vm._v("Red/红色")] : _vm._e(), _vm._v(" "), _c('small', [_vm._v("Position/位置: " + _vm._s(result.direction))])], 2), _vm._v(" "), _c('span', [_c('small', [_vm._v("Selection/选择: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(result.selection))]), _vm._v(" "), _c('small', [_vm._v(" - " + _vm._s(result.response) + "ms")]), _vm._v(" "), (result.selection === result.direction) ? _c('md-icon', {
      staticClass: "md-primary",
      attrs: {
        "md-theme": "green"
      }
    }, [_vm._v("∨")]) : _c('md-icon', {
      staticClass: "md-warn",
      attrs: {
        "md-theme": "orange"
      }
    }, [_vm._v("x")])], 1)], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.type === _vm.TYPE_IQ && _vm.IQscore) ? _c('div', {
    staticClass: "score"
  }, [_vm._v("Score/最后得分：" + _vm._s(_vm.IQscore) + "/60")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 176:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 63:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(111)
}
var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(85),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 84:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_material_dist_vue_material_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('focus', {
  inserted: function inserted(el) {
    setInterval(function () {
      return el.focus();
    }, 50);
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_dashboard__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    var json = '{\n      "picture-naming": [\n        "015", "016", "027", "040", "044", "105", "109", "128", "155", "215", "222"\n      ],\n      "lexical-decision": {\n        "chinese": {\n          "words": [\n            "001", "002", "003", "004", "005", "006", "007", "008", "009", "010",\n            "011", "012", "013", "014", "015", "016", "017", "018", "019", "020",\n            "021", "022", "023", "024", "025", "026", "027", "028", "029", "030",\n            "031", "032", "033", "034", "035", "036", "037", "038", "039", "040",\n            "041", "042", "043", "044", "045", "046", "047", "048"\n          ],\n          "nonwords": [\n            "005-7", "006-5", "012-6", "030-5", "020-7", "021-7", "019-6", "018-6",\n            "045-5", "093-5", "089-5", "085-7", "074-7", "083-7", "104-5", "106-5",\n            "077-6", "120-5", "160-5", "139-6", "123-6", "151-6", "159-6", "157-6",\n            "172-6", "162-6", "181-5", "164-7", "173-7", "189-5", "142-7", "212-5",\n            "204-5", "217-6", "220-6", "236-6", "209-7", "225-7", "243-5", "234-7",\n            "228-6", "240-7", "263-7", "281-7", "313-5", "324-7", "577-6", "521-6"\n          ]\n        },\n        "uyghur": {  \n          "words": [\n            "001", "002", "003", "004", "007", "008", "009", "010",\n            "011", "012", "013", "014", "015", "016", "017", "018", "019", "020",\n            "021", "022", "023", "024", "025", "026", "027", "028", "029", "030",\n            "031", "032", "033", "034", "035", "036", "037", "038", "039", "040",\n            "041", "042", "043", "044", "045", "046", "047", "048", "049", "050"\n          ],\n          "nonwords": [\n            "001", "002", "003", "004", "005", "006", "007", "008", "009", "010",\n            "011", "012", "013", "014", "015", "016", "017", "018", "019", "020",\n            "021", "022", "023", "024", "025", "026", "027", "028", "029", "030",\n            "031", "032", "033", "034", "035", "036", "038", "039", "040",\n            "041", "042", "043", "044", "045", "052", "053", "054", "055"\n          ]\n        }\n      },\n      "iq-tester": [\n        { "Q": "A01", "A": 4 }, { "Q": "A02", "A": 5 }, { "Q": "A03", "A": 1 }, { "Q": "A04", "A": 2 }, { "Q": "A05", "A": 6 }, { "Q": "A06", "A": 3 }, { "Q": "A07", "A": 6 }, { "Q": "A08", "A": 2 }, { "Q": "A09", "A": 1 }, { "Q": "A10", "A": 3 }, { "Q": "A11", "A": 5 }, { "Q": "A12", "A": 4 },\n        { "Q": "B01", "A": 2 }, { "Q": "B02", "A": 6 }, { "Q": "B03", "A": 1 }, { "Q": "B04", "A": 2 }, { "Q": "B05", "A": 1 }, { "Q": "B06", "A": 3 }, { "Q": "B07", "A": 5 }, { "Q": "B08", "A": 6 }, { "Q": "B09", "A": 4 }, { "Q": "B10", "A": 3 }, { "Q": "B11", "A": 4 }, { "Q": "B12", "A": 5 },\n        { "Q": "C01", "A": 8 }, { "Q": "C02", "A": 2 }, { "Q": "C03", "A": 3 }, { "Q": "C04", "A": 8 }, { "Q": "C05", "A": 7 }, { "Q": "C06", "A": 4 }, { "Q": "C07", "A": 5 }, { "Q": "C08", "A": 1 }, { "Q": "C09", "A": 7 }, { "Q": "C10", "A": 6 }, { "Q": "C11", "A": 1 }, { "Q": "C12", "A": 2 },\n        { "Q": "D01", "A": 3 }, { "Q": "D02", "A": 4 }, { "Q": "D03", "A": 3 }, { "Q": "D04", "A": 7 }, { "Q": "D05", "A": 8 }, { "Q": "D06", "A": 6 }, { "Q": "D07", "A": 5 }, { "Q": "D08", "A": 4 }, { "Q": "D09", "A": 1 }, { "Q": "D10", "A": 2 }, { "Q": "D11", "A": 5 }, { "Q": "D12", "A": 6 },\n        { "Q": "E01", "A": 7 }, { "Q": "E02", "A": 6 }, { "Q": "E03", "A": 8 }, { "Q": "E04", "A": 2 }, { "Q": "E05", "A": 1 }, { "Q": "E06", "A": 5 }, { "Q": "E07", "A": 2 }, { "Q": "E08", "A": 4 }, { "Q": "E09", "A": 1 }, { "Q": "E10", "A": 6 }, { "Q": "E11", "A": 3 }, { "Q": "E12", "A": 5 }\n      ],\n      "flanker": [\n        { "count": 21, "type": "con", "direction": "right" },\n        { "count": 21, "type": "con", "direction": "left" },\n        { "count": 21, "type": "incon", "direction": "right" },\n        { "count": 21, "type": "incon", "direction": "left" },\n        { "count": 21, "type": "neu", "direction": "right" },\n        { "count": 21, "type": "neu", "direction": "left" }\n      ],\n      "simon": [\n        { "count": 21, "type": "red", "direction": "right" },\n        { "count": 21, "type": "red", "direction": "left" },\n        { "count": 21, "type": "red", "direction": "center" },\n        { "count": 21, "type": "blue", "direction": "right" },\n        { "count": 21, "type": "blue", "direction": "left" },\n        { "count": 21, "type": "blue", "direction": "center" }\n      ]\n    }';
    var demo = '{\n      "picture-naming": [ "073", "086", "227", "250" ],\n      "lexical-decision": {\n        "chinese": {\n          "words": [ "049", "050", "051", "052" ],\n          "nonwords": [ "527-6", "552-7", "558-5", "597-5" ]\n        },\n        "uyghur": {  \n          "words": [ "051", "052", "053", "054" ],\n          "nonwords": [ "046", "047", "048", "049" ]\n        }\n      },\n      "iq-tester": [\n        { "Q": "A01", "A": 3 },\n        { "Q": "A02", "A": 4 },\n        { "Q": "A03", "A": 5 },\n        { "Q": "A04", "A": 1 }\n      ],\n      "flanker": [\n        { "count": 2, "type": "con", "direction": "right" },\n        { "count": 2, "type": "con", "direction": "left" },\n        { "count": 2, "type": "incon", "direction": "right" },\n        { "count": 2, "type": "incon", "direction": "left" },\n        { "count": 2, "type": "neu", "direction": "right" },\n        { "count": 2, "type": "neu", "direction": "left" }\n      ],\n      "simon": [\n        { "count": 2, "type": "red", "direction": "right" },\n        { "count": 2, "type": "red", "direction": "left" },\n        { "count": 2, "type": "red", "direction": "center" },\n        { "count": 2, "type": "blue", "direction": "right" },\n        { "count": 2, "type": "blue", "direction": "left" },\n        { "count": 2, "type": "blue", "direction": "center" }\n      ]\n    }';
    return {
      designs: JSON.parse(json),
      demo: JSON.parse(demo)
    };
  },
  mounted: function mounted() {
    window.onbeforeunload = function (e) {
      var message = '是否确认关闭当前窗口？';
      e = e || window.event;

      if (e) {
        e.returnValue = message;
      }

      return message;
    };
  },
  components: {
    Dashboard: __WEBPACK_IMPORTED_MODULE_0__components_dashboard___default.a
  }
});

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Flanker',
  props: ['item'],
  data: function data() {
    return {
      KEY: {
        LEFT: 65,
        RIGHT: 76
      },
      startDate: 0,
      status: null,
      steps: [],
      result: {
        type: this.item.type,
        direction: this.item.direction,
        selection: null,
        response: 0
      },
      isMac: false
    };
  },
  watch: {
    status: function status() {
      if (this.status === 'end') {
        this.end();
        this.$emit('end', this.result);
      } else if (this.status === 'playing') {
        this.startDate = new Date();
      } else if (this.status === 'feedback') {
        this.setStatus('end', this.steps[3]);
      }
    }
  },
  methods: {
    end: function end(event) {
      if (!event) {
        this.record();
      } else if (this.status === 'playing') {
        if (event.keyCode === this.KEY.RIGHT) {
          this.result.selection = 'right';
        } else if (event.keyCode === this.KEY.LEFT) {
          this.result.selection = 'left';
        }
        if (this.result.selection) {
          clearTimeout(this.endTimeout);
          this.setStatus('feedback');
          this.record();
        }
      }
    },
    record: function record() {
      if (this.startDate) {
        this.result.response = new Date() - this.startDate;
        this.startDate = 0;
      }
    },
    setStatus: function setStatus(status, timeout) {
      var _this = this;

      if (timeout) {
        return setTimeout(function () {
          _this.status = status;
        }, timeout);
      } else {
        this.status = status;
      }
    }
  },
  computed: {
    arrowText: function arrowText() {
      return String.fromCharCode('\8594');
    },
    feedback: function feedback() {
      var feedback = '';
      if (this.result.selection === null) {
        feedback = '反应超时';
      } else {
        feedback = this.isCorrect ? '正确' : '错误';
      }
      return feedback;
    },
    isCorrect: function isCorrect() {
      return this.result.selection === this.result.direction;
    }
  },
  mounted: function mounted() {
    this.steps = [500, 250, 2000, 250];
    this.setStatus('start');
    this.setStatus('ready', this.steps[0]);
    this.setStatus('playing', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 2)));
    this.endTimeout = this.setStatus('feedback', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 3)));
    this.isMac = window.navigator.platform === 'MacIntel';
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'IQTester',
  props: ['item', 'language'],
  data: function data() {
    return {
      startDate: 0,
      status: null,
      result: {
        name: this.item.Q,
        answer: this.item.A,
        response: 0,
        choice: 0,
        src: ''
      }
    };
  },
  watch: {
    status: function status() {
      if (this.status === 'end') {
        this.end();
        this.$emit('end', this.result);
      } else if (this.status === 'playing') {
        this.startDate = new Date();
      }
    }
  },
  methods: {
    end: function end(event) {
      if (!event) {
        this.record();
      } else if (this.status === 'playing') {
        this.record();
        if (event.keyCode > 48 && event.keyCode < 57) {
          this.status = 'end';
          clearTimeout(this.endTimeout);
          this.result.choice = event.keyCode - 48;
        }
      }
    },
    record: function record() {
      if (this.startDate) {
        this.result.response = new Date() - this.startDate;
        this.result.src = this.imageSrc;
        this.startDate = 0;
      }
    }
  },
  computed: {
    imageSrc: function imageSrc() {
      return './static/iq-tester/' + this.item.Q + '.jpg';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.status = 'playing';
    this.endTimeout = setTimeout(function () {
      _this.status = 'end';
    }, 40 * 60 * 1000);
  },
  directives: {
    focus: {
      inserted: function inserted(el) {
        setInterval(function () {
          return el.focus();
        }, 50);
      }
    }
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'LexicalDecision',
  props: ['item', 'language'],
  data: function data() {
    return {
      KEY: {
        REAL: 65,
        FAKE: 76
      },
      startDate: 0,
      status: null,
      steps: [],
      result: {
        name: this.item.name,
        isNon: this.item.isNon,
        response: 0,
        selection: null,
        language: this.language,
        src: ''
      }
    };
  },
  watch: {
    status: function status() {
      if (this.status === 'end') {
        this.end();
        this.$emit('end', this.result);
      } else if (this.status === 'playing') {
        this.startDate = new Date();
      } else if (this.status === 'feedback') {
        this.setStatus('end', this.steps[3]);
      }
    }
  },
  methods: {
    end: function end(event) {
      if (!event) {
        this.record();
      } else if (this.status === 'playing') {
        this.record();
        if (event.keyCode === this.KEY.REAL) {
          this.result.selection = true;
        } else if (event.keyCode === this.KEY.FAKE) {
          this.result.selection = false;
        }
        if (this.result.selection !== null) {
          clearTimeout(this.endTimeout);
          this.setStatus('feedback');
        }
      }
    },
    record: function record() {
      if (this.startDate) {
        this.result.response = new Date() - this.startDate;
        this.result.src = this.imageSrc;
        this.startDate = 0;
      }
    },
    setStatus: function setStatus(status, timeout) {
      var _this = this;

      if (timeout) {
        return setTimeout(function () {
          _this.status = status;
        }, timeout);
      } else {
        this.status = status;
      }
    }
  },
  computed: {
    imageSrc: function imageSrc() {
      return './static/lexical-decision/' + this.language + '-' + (this.item.isNon ? 'nonwords' : 'words') + '/' + this.item.name + '.png';
    },
    feedback: function feedback() {
      var feedback = '';
      if (this.result.selection === null) {
        feedback = '反应超时';
      } else {
        feedback = this.result.selection !== this.result.isNon ? '正确' : '错误';
      }
      return feedback;
    }
  },
  mounted: function mounted() {
    this.steps = [1000, 250, 2000, 250];
    this.setStatus('start');
    this.setStatus('ready', this.steps[0]);
    this.setStatus('playing', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 2)));
    this.endTimeout = this.setStatus('feedback', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 3)));
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_msr__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_msr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_msr__);





var SpeechRecognition = window.webkitSpeechRecognition;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'PictureNaming',
  props: ['item', 'language'],
  data: function data() {
    return {
      startDate: 0,
      status: null,
      result: {
        name: this.item.name,
        isEnd: this.item.isEnd,
        switch: '',
        language: this.item.language,
        response: 0,
        record: null,
        src: ''
      },
      recognition: new SpeechRecognition(),
      media: null
    };
  },
  watch: {
    status: function status() {
      if (this.status === 'end') {
        this.recognition.onspeechstart = function () {};
        this.media.stop();
        this.record();
        this.$emit('end', this.result);
      } else if (this.status === 'playing') {
        this.startDate = new Date();
        this.media.start(5000);
      } else if (this.status === 'prompt') {
        this.recognition.start();
      }
    }
  },
  methods: {
    loadRecorder: function loadRecorder() {
      var _this = this;

      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia;
      navigator.getUserMedia({
        audio: true
      }, function (stream) {
        _this.media = new __WEBPACK_IMPORTED_MODULE_1_msr___default.a(stream);
        _this.media.mimeType = 'audio/wav';
        _this.media.ondataavailable = function (blob) {
          _this.result.record = blob;
        };
      }, function (error) {
        console.error('media error', error);
      });
    },
    record: function record(callback) {
      if (this.startDate) {
        this.result.response = __WEBPACK_IMPORTED_MODULE_0_lodash__["min"]([4000, new Date() - this.startDate]);
        this.result.src = this.imageSrc;
        this.result.switch = this.isChanged;
        this.startDate = 0;
        callback && callback();
      }
    },
    setStatus: function setStatus(status, timeout) {
      var _this2 = this;

      if (timeout) {
        setTimeout(function () {
          _this2.status = status;
        }, timeout);
      } else {
        this.status = status;
      }
    }
  },
  computed: {
    languageSay: function languageSay() {
      return {
        chinese: '说',
        uyghur: 'سۆزلەڭ',
        english: 'Say'
      }[this.item.language];
    },
    imageSrc: function imageSrc() {
      return './static/picture-naming/' + this.item.name + '.gif';
    },
    isChanged: function isChanged() {
      var isChange = 'Not changed';
      if (this.item.isChange) {
        isChange = 'Changed';
      } else if (this.item.isChange === null) {
        isChange = 'First';
      }
      return isChange;
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.loadRecorder();
    var steps = [1000, 250, 500, 4000];
    if (this.item.isEnd) {
      steps.push(1000);
    }
    this.recognition.onspeechstart = function () {
      console.log(_this3.status);
      if (_this3.status === 'playing') {
        _this3.record(function () {
          _this3.status = 'saying';
        });
      } else {
        var onspeechstart = _this3.recognition.onspeechstart;
        _this3.recognition = new SpeechRecognition();
        _this3.recognition.onspeechstart = onspeechstart;
        _this3.recognition.start();
      }
    };
    this.setStatus('start');
    this.setStatus('ready', steps[0]);
    this.setStatus('prompt', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](steps, 0, 2)));
    this.setStatus('playing', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](steps, 0, 3)));
    if (this.item.isEnd) {
      this.setStatus('group', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](steps, 0, 4)));
    }
    this.setStatus('end', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](steps));
  }
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Simon',
  props: ['item'],
  data: function data() {
    return {
      KEY: {
        RED: 65,
        BLUE: 76
      },
      startDate: 0,
      status: null,
      steps: [],
      result: {
        type: this.item.type,
        direction: this.item.direction,
        selection: null,
        response: 0
      }
    };
  },
  watch: {
    status: function status() {
      if (this.status === 'end') {
        this.end();
        this.$emit('end', this.result);
      } else if (this.status === 'playing') {
        this.startDate = new Date();
      } else if (this.status === 'feedback') {
        this.setStatus('end', this.steps[3]);
      }
    }
  },
  methods: {
    end: function end(event) {
      if (!event) {
        this.record();
      } else if (this.status === 'playing') {
        if (event.keyCode === this.KEY.BLUE) {
          this.result.selection = 'blue';
        } else if (event.keyCode === this.KEY.RED) {
          this.result.selection = 'red';
        }
        if (this.result.selection) {
          clearTimeout(this.endTimeout);
          this.setStatus('feedback');
          this.record();
        }
      }
    },
    record: function record() {
      if (this.startDate) {
        this.result.response = new Date() - this.startDate;
        this.startDate = 0;
      }
    },
    setStatus: function setStatus(status, timeout) {
      var _this = this;

      if (timeout) {
        return setTimeout(function () {
          _this.status = status;
        }, timeout);
      } else {
        this.status = status;
      }
    }
  },
  computed: {
    feedback: function feedback() {
      var feedback = '';
      if (this.result.selection === null) {
        feedback = '反应超时';
      } else {
        feedback = this.isCorrect ? '正确' : '错误';
      }
      return feedback;
    },
    isCorrect: function isCorrect() {
      return this.result.selection === this.result.type;
    }
  },
  mounted: function mounted() {
    this.steps = [500, 250, 2000, 250];
    this.setStatus('start');
    this.setStatus('ready', this.steps[0]);
    this.setStatus('playing', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 2)));
    this.endTimeout = this.setStatus('feedback', __WEBPACK_IMPORTED_MODULE_0_lodash__["sum"](__WEBPACK_IMPORTED_MODULE_0_lodash__["slice"](this.steps, 0, 3)));
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_screenfull__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_screenfull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_screenfull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PictureNaming__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PictureNaming___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PictureNaming__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LexicalDecision__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LexicalDecision___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__LexicalDecision__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Flanker__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Flanker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Flanker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Simon__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Simon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Simon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IQTester__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__IQTester___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__IQTester__);















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Dashboard',
  props: ['design', 'demo'],
  data: function data() {
    var data = {
      type: '',
      saved: false,
      TYPE_PIC: 'picture-naming',
      TYPE_IQ: 'iq-tester',
      TYPE_LEX: 'lexical-decision',
      TYPE_LEX_CN: 'lexical-decision-chinese',
      TYPE_LEX_UG: 'lexical-decision-uyghur',
      TYPE_SIMON: 'simon',
      TYPE_FLANKER: 'flanker',
      language: 'chinese',
      current: -1,
      list: [],
      results: {},
      demoData: {},
      SECTION_COUNT: 6,
      showError: false,
      yourname: '',
      contact: '',
      realMode: false,
      nextTimeout: null,
      KEY: {
        START: 32
      }
    };
    data.type = data.TYPE_PIC;
    data.results[data.TYPE_PIC] = [];
    data.results[data.TYPE_LEX_CN] = [];
    data.results[data.TYPE_LEX_UG] = [];
    data.results[data.TYPE_IQ] = [];
    data.results[data.TYPE_FLANKER] = [];
    data.results[data.TYPE_SIMON] = [];
    data.demoData[data.TYPE_PIC] = [];
    data.demoData[data.TYPE_LEX_CN] = [];
    data.demoData[data.TYPE_LEX_UG] = [];
    data.demoData[data.TYPE_IQ] = [];
    data.demoData[data.TYPE_FLANKER] = [];
    data.demoData[data.TYPE_SIMON] = [];
    return data;
  },

  methods: {
    blobUrl: function blobUrl(url) {
      return url && URL.createObjectURL(url);
    },
    start: function start() {
      var _this = this;

      if (!this.contact) {
        this.showError = true;
        return;
      }
      this.current = -1;
      if (__WEBPACK_IMPORTED_MODULE_5_screenfull__["enabled"]) {
        __WEBPACK_IMPORTED_MODULE_5_screenfull__["request"](this.$refs.container);
        __WEBPACK_IMPORTED_MODULE_5_screenfull__["onchange"](function (event) {
          if (!__WEBPACK_IMPORTED_MODULE_5_screenfull__["isFullscreen"]) {
            clearTimeout(_this.nextTimeout);
            _this.current = -1;
          }
        });
      }
      this.list = this.random();
      console.log('list', this.list);
      this.$nextTick(function () {
        _this.current = 0;
      });
    },
    play: function play(event) {
      if (event.keyCode === this.KEY.START) {
        this.current = 1;
      }
    },
    next: function next(result) {
      var _this2 = this;

      if (result) {
        if (this.realMode) {
          this.results[this.sumType].push(result);
        } else {
          this.demoData[this.sumType].push(result);
        }

        if (this.current === this.list.length) {
          this.current = -1;
          __WEBPACK_IMPORTED_MODULE_5_screenfull__["exit"]();
          this.upload();
        } else {
          this.nextTimeout = setTimeout(function () {
            _this2.current++;
          }, 500);
        }
      }
    },
    random: function random() {
      var mapper = {};
      mapper[this.TYPE_PIC] = 'randomPictures';
      mapper[this.TYPE_LEX] = 'randomLexical';
      mapper[this.TYPE_IQ] = 'randomIQ';
      mapper[this.TYPE_FLANKER] = 'randomExperiment';
      mapper[this.TYPE_SIMON] = 'randomExperiment';
      var methodName = mapper[this.type];
      return this[methodName]();
    },
    randomExperiment: function randomExperiment() {
      var list = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatMap"](this.items, function (item) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash__["fill"](Array(item.count), item);
      });
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["sampleSize"](list, list.length);
    },
    randomIQ: function randomIQ() {
      return this.items;
    },
    randomLexical: function randomLexical() {
      var languageGroup = this.items[this.language];
      var nonwords = __WEBPACK_IMPORTED_MODULE_2_lodash__["map"](languageGroup.nonwords, function (word) {
        return {
          name: word,
          isNon: true
        };
      });
      var words = __WEBPACK_IMPORTED_MODULE_2_lodash__["map"](languageGroup.words, function (word) {
        return {
          name: word,
          isNon: false
        };
      });
      var allWords = __WEBPACK_IMPORTED_MODULE_2_lodash__["concat"](nonwords, words);
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["sampleSize"](allWords, allWords.length);
    },
    logPictures: function logPictures(randomItems) {
      console.group('=========================================');
      __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](randomItems, function (item) {
        console.group('---------------------');
        console.log('picture name:', item.name);
        console.log('language:', item.language);
        if (item.isChange) {
          console.log('Changed');
        } else if (item.isChange === null) {
          console.log('First');
        } else {
          console.log('Not changed');
        }
        console.groupEnd('---------------------');
        if (item.isEnd) {
          console.groupEnd('<=========================================>');
          console.group('<=========================================>');
        }
      });
    },
    randomPictures: function randomPictures() {
      var uyghurGroups = this.randomPictureGroup('uyghur', this.groupImages(this.items));
      var ChineseGroups = this.randomPictureGroup('chinese', this.groupImages(this.items));
      var groups = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"]([uyghurGroups, ChineseGroups]);
      var randomGroups = __WEBPACK_IMPORTED_MODULE_2_lodash__["sampleSize"](groups, groups.length);
      var randomItems = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"](randomGroups);
      this.logPictures(randomItems);
      return randomItems;
    },
    randomPictureGroup: function randomPictureGroup(languageName, imgGroups) {
      var languages = ['uyghur', 'chinese'];
      var another = {};
      another[languages[0]] = languages[1];
      another[languages[1]] = languages[0];
      var imagesCount = __WEBPACK_IMPORTED_MODULE_2_lodash__["size"](__WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"](imgGroups));
      var pairCount = imagesCount - imgGroups.length;
      var changeLanguagesCount = __WEBPACK_IMPORTED_MODULE_2_lodash__["round"](pairCount * (1 / 3));
      var keepLanguagesCount = __WEBPACK_IMPORTED_MODULE_2_lodash__["round"]((pairCount - changeLanguagesCount) * 0.5);
      var keepLanguagesCounter = {};
      __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](languages, function (langName) {
        keepLanguagesCounter[langName] = keepLanguagesCount;
      });
      var itemGroups = __WEBPACK_IMPORTED_MODULE_2_lodash__["map"](imgGroups, function (imgGroup, groupIndex) {
        return __WEBPACK_IMPORTED_MODULE_2_lodash__["map"](imgGroup, function (image, index) {
          var isChange = null;
          if (index > 0) {
            isChange = false;
          }
          if (isChange !== null) {
            var randomValue = __WEBPACK_IMPORTED_MODULE_2_lodash__["random"](true);
            var totalCount = imagesCount - imgGroups.length + groupIndex + 1;
            var shouldChange = randomValue < changeLanguagesCount / totalCount;
            var canNotKeep = keepLanguagesCounter[languageName] === 0;
            var mustKeep = changeLanguagesCount === 1 && keepLanguagesCounter[languageName] > 0;
            if (!mustKeep && (shouldChange || canNotKeep)) {
              languageName = another[languageName];
              changeLanguagesCount--;
              isChange = true;
            } else {
              keepLanguagesCounter[languageName]--;
            }
          }
          imagesCount--;
          var item = {
            name: image,
            language: languageName,
            isEnd: imgGroup.length === index + 1,
            isChange: isChange
          };
          if (isChange) {
            console.count('Changed from ' + another[languageName] + ' to ' + languageName);
          } else if (isChange === false) {
            console.count('Keep ' + languageName);
          } else {
            console.count('First ' + languageName);
          }
          return item;
        });
      });
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["sampleSize"](itemGroups, this.sectionCount);
    },
    groupImages: function groupImages(imgs) {
      var _this3 = this;

      var imageCountInGroup = imgs.length;
      var minRange = imageCountInGroup - this.sectionCount;
      var maxRange = imageCountInGroup + this.sectionCount;
      var left = 0;
      var groups = __WEBPACK_IMPORTED_MODULE_2_lodash__["chain"](Array(this.sectionCount)).map(function (val, index) {
        return function (self) {
          var min = minRange;
          var max = maxRange;
          if (left > 0) {
            min += left;
          } else {
            max += left;
          }
          if (index + 1 === self.sectionCount) {
            return imageCountInGroup + left;
          } else {
            var size = __WEBPACK_IMPORTED_MODULE_2_lodash__["random"](min, max);
            left += imageCountInGroup - size;
            return size;
          }
        }(_this3);
      }).sortBy(function (size) {
        return size;
      }).value();
      var pool = __WEBPACK_IMPORTED_MODULE_2_lodash__["flatten"](__WEBPACK_IMPORTED_MODULE_2_lodash__["fill"](Array(this.sectionCount), imgs));
      var currentIndex = 0;
      console.log('Sum:', __WEBPACK_IMPORTED_MODULE_2_lodash__["sum"](groups));
      console.log('Group count:', groups.join(','));
      var results = __WEBPACK_IMPORTED_MODULE_2_lodash__["map"](groups, function (count) {
        var result = __WEBPACK_IMPORTED_MODULE_2_lodash__["slice"](pool, currentIndex, currentIndex + count);
        currentIndex += count;
        var randomResult = __WEBPACK_IMPORTED_MODULE_2_lodash__["sampleSize"](result, count);
        return _this3.sortedWithSpace(randomResult, _this3.realMode ? 3 : 1);
      });
      return results;
    },
    sortedWithSpace: function sortedWithSpace(arr, gap) {
      var results = [];
      var cache = [];
      var pick = function pick(item) {
        var cached = false;
        if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"](__WEBPACK_IMPORTED_MODULE_2_lodash__["slice"](results, 0 - gap), item)) {
          results.push(item);
        } else if (!__WEBPACK_IMPORTED_MODULE_2_lodash__["includes"](__WEBPACK_IMPORTED_MODULE_2_lodash__["slice"](results, 0, gap), item)) {
          results.unshift(item);
        } else {
          cache.push(item);
          cached = true;
        }
        return cached;
      };
      __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](arr, function (item) {
        pick(item);
        cache = __WEBPACK_IMPORTED_MODULE_2_lodash__["filter"](cache, pick);
      });
      console.log('sorted images:', results);
      return results;
    },
    upload: function upload(event) {
      var _result,
          _this4 = this;

      if (!this.realMode) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.post("http://api.tych.io/experiment", {
        name: this.contact,
        result: (_result = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_PIC, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_PIC])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_LEX_CN, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_LEX_CN])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_LEX_UG, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_LEX_UG])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_FLANKER, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_FLANKER])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_SIMON, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_SIMON])), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_result, this.TYPE_IQ, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.results[this.TYPE_IQ])), _result)
      }).then(function (response) {
        if (response.data) {
          _this4.saved = !!event;
        }
      });
    },
    download: function download() {
      var _this5 = this;

      var zip = new __WEBPACK_IMPORTED_MODULE_3_jszip___default.a();
      var folder = zip.folder('psychio_results_' + this.contact);
      __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](this.results, function (result, type) {
        __WEBPACK_IMPORTED_MODULE_2_lodash__["each"](result, function (item, index) {
          var fileName = [type, (__WEBPACK_IMPORTED_MODULE_2_lodash__["fill"](Array(3), '0').join('') + (index + 1)).slice(-3)].join('_');
          if (item.record) {
            folder.file(fileName + '.wav', item.record);
          }
          item.number = fileName;
        });
      });

      folder.file('info.json', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        name: this.yourname,
        contact: this.contact,
        results: this.results
      }));

      zip.generateAsync({ type: 'blob' }).then(function (content) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_file_saver__["saveAs"])(content, 'psychio_results_' + _this5.contact + '.zip');
      });
    }
  },
  computed: {
    items: function items() {
      if (this.realMode) {
        return this.design[this.type];
      } else {
        return this.demo[this.type];
      }
    },
    sectionCount: function sectionCount() {
      return this.realMode ? this.SECTION_COUNT : 2;
    },
    sumType: function sumType() {
      var type = this.type;
      if (type === this.TYPE_LEX) {
        type += '-' + this.language;
      }
      return type;
    },
    hasData: function hasData() {
      var hasPictures = this.results[this.TYPE_PIC].length;
      var hasLexicalChinese = this.results[this.TYPE_LEX_CN].length;
      var hasLexicalUyghur = this.results[this.TYPE_LEX_UG].length;
      return hasPictures || hasLexicalChinese || hasLexicalUyghur;
    },
    IQscore: function IQscore() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash__["countBy"](this.results[this.TYPE_IQ], function (result) {
        return result.answer === result.choice;
      })['true'];
    },
    instructionContent: function instructionContent() {
      var content = {};
      var params = window.location.search.match(/(l=)([\w-]+)/);
      if (params && params.length >= 3 && params[2] === 'en-US') {
        content = {
          header: 'Welcome to the experiment!',
          footer: 'Press SPACE bar to start the experiment.'
        };
        content[this.TYPE_LEX_UG] = ['Now you will be presented with a series of words.', 'If the stimulus is a real Uyghur word, press “Red” key as quick as possible;', 'If the stimulus is a non-Uyghur word, press “Blue” key as quick as possible.'].join('<br/>');
        content[this.TYPE_LEX_CN] = ['Now you will be presented with a series of characters.', 'If the stimulus is a real Chinese character, press ”Red” key as quick as possible;', 'If the stimulus is a non-Chinese character, press “Blue” key as quick as possible.'].join('<br/>');
        content[this.TYPE_PIC] = ['You will be required to name pictures respectively in Uyghur and Chinese.', 'If you see the cue “说”, speak out the name of following picture in Chinese as quickly as possible;', 'if you see the cue “سۆزلەڭ”, speak out the name of following picture in Uyghur as quickly as possible.', 'Try to name the picture as quickly and accurately as possible.'].join('<br/>');
        content[this.TYPE_SIMON] = ['In the experiment, if you see the red square, press “Red” key as quickly as possible;', 'if you see the blue square, press “Blue” key as quickly as possible, regardless of its location on the screen.', 'Press the correct key as quickly as possible.'].join('<br/>');
        content[this.TYPE_FLANKER] = ['You will be presented with a series of arrows, choose the direction pointed by the arrow in the CENTRE as quickly as you can, regardless of the direction of other surrounding arrows.', 'If the arrow in the centre is pointing to the left, press the “Red” key.', 'If the arrow in the centre is pointing to the right, press the “Blue” key;'].join('<br/>');
        content[this.TYPE_IQ] = ['Please answer the following 60 questions within 20 minutes. 5 groups in all (A-E)， 12 questions for each group.', 'Please answer question with number'].join('<br/>');
      } else {
        content = {
          header: '欢迎参加实验！',
          footer: '按空格键开始实验。'
        };
        content[this.TYPE_LEX_UG] = ['你将会看到一系列单词。', '如果该单词为真维文词，请按红色键；', '如果该单词为假维文词，请按蓝色键。'].join('<br/>');
        content[this.TYPE_LEX_CN] = ['你将会看到一系列汉字。', '如果该字为真汉字，请按红色键；', '如果该字为假汉字，请按蓝色键。'].join('<br/>');
        content[this.TYPE_PIC] = ['你将分别用维语和汉语对出现的图片进行命名。', '看到提示字为“说”时，请用汉语命名接下来出现的图片；', '看到提示字为 " سۆزلەڭ”时，请用维语命名接下来出现的图片。'].join('<br/>');
        content[this.TYPE_SIMON] = ['在实验中，看到红色方块时，请按红色键；', '看到蓝色方块时，请按蓝色键；', '不用管图形出现在屏幕中的位置。'].join('<br/>');
        content[this.TYPE_FLANKER] = ['你将会看到一系列的箭头，请判断中间位置箭头所指的方向，不用管旁边的箭头方向。', '如果中间的箭头指向左边，请按红色键。', '如果中间的箭头指向右边，请按蓝色键；'].join('<br/>');
        content[this.TYPE_IQ] = ['请在20分钟内作答下列60道题。共5组（A-E），每组各12题。', '请按相应的数字键进行作答。'].join('<br>');
      }

      return content;
    }
  },
  components: {
    'picture-naming': __WEBPACK_IMPORTED_MODULE_7__PictureNaming___default.a,
    'lexical-decision': __WEBPACK_IMPORTED_MODULE_8__LexicalDecision___default.a,
    'flanker': __WEBPACK_IMPORTED_MODULE_9__Flanker___default.a,
    'simon': __WEBPACK_IMPORTED_MODULE_10__Simon___default.a,
    'iq-tester': __WEBPACK_IMPORTED_MODULE_11__IQTester___default.a
  }
});

/***/ })

},[84]);


// WEBPACK FOOTER //
// static/js/app.46229a36ab665619c655.js